import { Avatar, Box, Typography } from '@mui/material'

export interface RelationshipCardData {
  caregiverName: string
  relationshipName: string | null
  financiallyResponsibleFor: boolean | null
  livesWithChild: boolean
}

export interface RelationshipCardProps {
  relationship: RelationshipCardData
  childName: string
  onModify: () => void
}

export function RelationshipCard (props: RelationshipCardProps): JSX.Element {
  const { relationship, childName } = props
  const details: string[] = []
  if (relationship.relationshipName != null) details.push(relationship.relationshipName)
  if (relationship.financiallyResponsibleFor === true) details.push(`Financially Responsible for ${childName}`)
  if (relationship.livesWithChild) details.push(`Lives with ${childName}`)

  return (
    <Box sx={{ backgroundColor: '#ECEDEF', borderRadius: '10px', p: '16px', display: 'flex', flexDirection: 'column', gap: '10px' }}>
      <Box sx={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
        <Avatar sx={{ height: '32px', width: '32px' }} />
        <Box sx={{ flex: '1 0 0', minWidth: 0 }}>
          <Typography sx={{ fontWeight: 700, fontSize: '14px', color: '#222024' }}>{relationship.caregiverName}</Typography>
          {details.map(detail => (
            <Typography key={detail} sx={{ fontSize: '14px', color: '#514F53' }}>{detail}</Typography>
          ))}
        </Box>
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <Typography
          onClick={props.onModify}
          data-testid='modifyRelationship'
          sx={{ fontSize: '16px', color: '#222024', textDecoration: 'underline', cursor: 'pointer', textAlign: 'center' }}
        >
          Modify Relationship
        </Typography>
      </Box>
    </Box>
  )
}
